import { Link } from 'react-router-dom'

import styled from 'styled-components'

export const Container = styled.main`
  width: 100%;
  min-height: 100vh;
  padding: 70px 0 72px;
  background: #f8f8f7;
  color: #333;
`

export const Hero = styled.section`
  padding: 54px 24px 40px;
  background: #fff;
  border-bottom: 1px solid #eeeeee;
`

export const HeroInner = styled.div`
  width: min(1240px, 100%);
  margin: 0 auto;
`

export const Eyebrow = styled.div`
  color: #e00000;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 8px;
`

export const HeroTitle = styled.h1`
  max-width: 900px;
  margin: 0;
  font-size: clamp(34px, 4vw, 50px);
  line-height: 1.06;
  color: #292929;

  strong {
    color: #e00000;
  }
`

export const HeroSubtitle = styled.p`
  max-width: 780px;
  margin: 14px 0 0;
  font-size: 17px;
  line-height: 1.65;
  color: #666;
`

export const SearchBar = styled.div`
  margin-top: 28px;
  max-width: 650px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 8px 5px 18px;
  border: 1px solid #dddddd;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

  svg {
    flex: 0 0 auto;
    color: #969696;
  }
`

export const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 44px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #333;
  font-size: 15px;

  &::placeholder {
    color: #9a9a9a;
  }
`

export const Content = styled.section`
  width: min(1240px, calc(100% - 48px));
  margin: 34px auto 0;
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr);
  gap: 24px;
  align-items: start;

  @media (max-width: 920px) {
    width: calc(100% - 28px);
    grid-template-columns: 1fr;
  }
`

export const Filters = styled.aside<{ $mobileOpen?: boolean }>`
  position: sticky;
  top: 92px;
  padding: 20px;
  border: 1px solid #e8e8e8;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.04);

  @media (max-width: 920px) {
    position: static;
  }

  @media (max-width: 580px) {
    position: fixed;
    left: 12px;
    right: 12px;
    bottom: 12px;
    z-index: 1250;
    display: ${({ $mobileOpen }) => ($mobileOpen ? 'block' : 'none')};
    max-height: min(82vh, 720px);
    overflow-y: auto;
    padding: 18px 16px 16px;
    border-radius: 22px;
    box-shadow: 0 22px 60px rgba(0, 0, 0, 0.24);
  }
`

export const FiltersHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  margin-bottom: 22px;
  color: #333;
  font-size: 17px;
  font-weight: 700;

  > div {
    display: flex;
    align-items: center;
    gap: 9px;
  }

  svg {
    color: #e00000;
    font-size: 15px;
  }

  @media (max-width: 580px) {
    margin-bottom: 16px;
  }
`

export const FilterGroup = styled.div`
  width: 100%;
`

export const FilterTitle = styled.h3`
  margin: 0 0 10px;
  color: #333;
  font-size: 15px;
`

export const FilterHint = styled.p`
  margin: -3px 0 14px;
  color: #8a8a8a;
  font-size: 12px;
  line-height: 1.45;
`

export const CostFields = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;

  @media (max-width: 580px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
`

export const FieldLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #666;
  font-size: 12px;
  font-weight: 600;
`

export const CostInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #dedede;
  border-radius: 10px;
  background: #fff;
  color: #333;
  font-size: 13px;
  outline: 0;

  &:focus {
    border-color: #c9c9c9;
    box-shadow: 0 0 0 3px rgba(224, 0, 0, 0.05);
  }
`

export const FilterDivider = styled.div`
  width: 100%;
  height: 1px;
  margin: 22px 0;
  background: #eeeeee;
`

export const InterestList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;

  @media (max-width: 580px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 7px;
  }
`

export const InterestLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 9px;
  color: #4b4b4b;
  font-size: 14px;
  cursor: pointer;

  input {
    width: 16px;
    height: 16px;
    accent-color: #e00000;
  }

  @media (max-width: 580px) {
    position: relative;
    gap: 0;

    input {
      position: absolute;
      width: 1px;
      height: 1px;
      opacity: 0;
      pointer-events: none;
    }

    span {
      padding: 8px 11px;
      border: 1px solid #dddddd;
      border-radius: 999px;
      background: #ffffff;
      color: #555555;
      font-size: 11px;
      line-height: 1;
      transition: 0.15s ease;
    }

    input:checked + span {
      border-color: rgba(224, 0, 0, 0.32);
      background: #fff2f2;
      color: #d50000;
      font-weight: 700;
    }
  }
`

export const ClearButton = styled.button`
  margin-top: 22px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #d60000;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    color: #b7b7b7;
    cursor: default;
  }

  @media (max-width: 580px) {
    min-height: 44px;
    margin-top: 0;
    padding: 0 16px;
    border: 1px solid #dedede;
    border-radius: 12px;
    background: #ffffff;
  }
`

export const Results = styled.div`
  min-width: 0;
`

export const ResultsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;

  @media (max-width: 580px) {
    margin-bottom: 12px;
    align-items: center;
    flex-direction: row;
  }
`

export const ResultCount = styled.div`
  strong {
    display: block;
    color: #333;
    font-size: 21px;
  }

  span {
    display: block;
    margin-top: 3px;
    color: #888;
    font-size: 13px;
  }
`

export const SortSelect = styled.select`
  height: 40px;
  padding: 0 34px 0 12px;
  border: 1px solid #dedede;
  border-radius: 10px;
  background: #fff;
  color: #444;
  font-size: 12px;
  outline: 0;

  @media (max-width: 580px) {
    display: none;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled(Link)`
  overflow: hidden;
  display: flex;
  min-width: 0;
  flex-direction: column;
  border: 1px solid #ece9e6;
  border-radius: 15px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.045);
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease;

  &:hover {
    color: inherit;
    transform: translateY(-2px);
    box-shadow: 0 9px 22px rgba(0, 0, 0, 0.08);
  }
`

type CardImageProps = { $image?: string }

export const CardImage = styled.div<CardImageProps>`
  position: relative;
  height: 138px;
  background-position: center;
  background-size: cover;
  background-color: #e7e7e7;
  background-image: ${({ $image }) =>
    $image
      ? `linear-gradient(180deg, rgba(0,0,0,0.01), rgba(0,0,0,0.12)), url("${$image}")`
      : 'linear-gradient(135deg, #e9e9e9, #d5d5d5)'};

  @media (max-width: 760px) {
    height: 160px;
  }
`

export const CollaborativeBadge = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  display: inline-flex;
  align-items: center;
  min-height: 25px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  color: #d00000;
  font-size: 9px;
  font-weight: 800;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
`

export const RatingBadge = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 27px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  font-size: 11px;
  font-weight: 700;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);

  svg {
    color: #f5ad00;
    font-size: 10px;
  }
`

export const CardBody = styled.div`
  display: flex;
  min-height: 128px;
  flex: 1;
  flex-direction: column;
  padding: 13px 14px 14px;
`

export const CardTitle = styled.h2`
  display: -webkit-box;
  overflow: hidden;
  min-height: 39px;
  margin: 0;
  color: #303030;
  font-size: 16px;
  line-height: 1.22;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`

export const Author = styled.p`
  overflow: hidden;
  margin: 5px 0 0;
  color: #929292;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: 8px;
  margin-top: auto;
  padding-top: 13px;
  border-top: 1px solid #f1f1f1;
`

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  color: #666;
  font-size: 10.5px;
  line-height: 1.2;

  svg {
    flex: 0 0 auto;
    color: #e00000;
    font-size: 10px;
  }

  span {
    overflow: hidden;
    min-width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const LoadMoreArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 0 4px;
`

export const LoadMoreStatus = styled.span`
  color: #888;
  font-size: 13px;
`

export const LoadMoreButton = styled.button`
  min-width: 190px;
  min-height: 44px;
  padding: 0 22px;
  border: 1px solid #e00000;
  border-radius: 999px;
  background: #fff;
  color: #e00000;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;

  &:hover {
    background: #e00000;
    color: #fff;
    transform: translateY(-1px);
  }
`

export const EmptyState = styled.div`
  padding: 54px 24px;
  border: 1px dashed #cccccc;
  border-radius: 16px;
  background: #fff;
  text-align: center;
  color: #777;
`

export const MobileFilterOverlay = styled.div`
  display: none;

  @media (max-width: 580px) {
    position: fixed;
    inset: 0;
    z-index: 1240;
    display: block;
    background: rgba(20, 20, 20, 0.52);
    backdrop-filter: blur(4px);
  }
`

export const MobileFilterClose = styled.button`
  display: none;

  @media (max-width: 580px) {
    width: 34px;
    height: 34px;
    border: 0;
    border-radius: 50%;
    background: #f3f3f3;
    color: #444444;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      color: #444444;
      font-size: 14px;
    }
  }
`

export const FilterActions = styled.div`
  @media (min-width: 581px) {
    display: block;
  }

  @media (max-width: 580px) {
    position: sticky;
    bottom: -16px;
    margin: 18px -16px -16px;
    padding: 12px 16px 16px;
    border-top: 1px solid #eeeeee;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 8px;
    background: #ffffff;
  }
`

export const ApplyFiltersButton = styled.button`
  display: none;

  @media (max-width: 580px) {
    min-height: 44px;
    border: 1px solid #e00000;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e00000;
    color: #ffffff;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
  }
`

export const MobileResultsToolbar = styled.div`
  display: none;

  @media (max-width: 580px) {
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 8px;
    margin-bottom: 12px;
  }
`

export const MobileFilterButton = styled.button`
  min-height: 42px;
  padding: 0 12px;
  border: 1px solid #dedede;
  border-radius: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: #ffffff;
  color: #3f3f3f;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;

  svg {
    color: #e00000;
    font-size: 12px;
  }

  strong {
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e00000;
    color: #ffffff;
    font-size: 8px;
  }
`

export const MobileSortSelect = styled.select`
  min-height: 42px;
  padding: 0 10px;
  border: 1px solid #dedede;
  border-radius: 11px;
  background: #ffffff;
  color: #444444;
  font-size: 11px;
  outline: 0;
`

export const ActiveFilters = styled.div`
  display: none;

  @media (max-width: 580px) {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin: -2px 0 14px;

    button {
      min-height: 30px;
      padding: 0 10px;
      border: 1px solid rgba(224, 0, 0, 0.2);
      border-radius: 999px;
      background: #fff4f4;
      color: #c90000;
      font-size: 9px;
      font-weight: 700;
      cursor: pointer;
    }
  }
`
